import React from 'react';
import styles from './index.module.less';
import { FooterContext, socialLinkItems } from '../../common';
import type { EIconType } from '@reolink-web/components.basic';
import { ReoIcon } from '@reolink-web/components.basic';

const CompAcceptPayWithSocial: React.FC = () => {
    const { country } = React.useContext(FooterContext);
    /**
     * 接受的支付方式
     */
    const acceptPayItems = React.useMemo(() => {
        return [
            {
                key: 'paypal',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/paypal.png.webp',
                alt: 'PayPal',
            },
            {
                key: 'visa',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/visa.png.webp',
                alt: 'Visa',
            },
            {
                key: 'mastercard',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/mastercard-1.png.webp',
                alt: 'MasterCard',
            },
            {
                key: 'maestro',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/maestro.png.webp',
                alt: 'Maestro',
            },
            {
                key: 'american-express',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/american-express.png.webp',
                alt: 'American Express',
            },
            {
                key: 'discover',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/discover.png.webp',
                alt: 'Discover',
            },
            {
                key: 'jcb',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/jcb.png.webp',
                alt: 'JCB',
            },
            {
                key: 'diners-club',
                img: 'https://home-cdn.reolink.us/wp-content/assets/2019/08/diners-club.png.webp',
                alt: 'Diners Club',
            },
            {
                key: 'google-pay',
                img: 'https://home-cdn.reolink.us/wp-content/assets/footer_google_pay.png.webp',
                alt: 'Google Pay',
            },
            {
                key: 'apple-pay',
                img: 'https://home-cdn.reolink.us/wp-content/assets/footer_apple_pay.png.webp',
                alt: 'Apple Pay',
            },
            ...(country === 'FR'
                ? [
                    {
                        key: 'cartes-bancaires',
                        img: 'https://home-cdn.reolink.us/wp-content/uploads/2025/05/Cartes-Bancaires.png.webp',
                        alt: 'Cartes-Bancaires',
                    },
                ]
                : []),
        ];
    }, [country]);
    return (
        <div className={ styles['accept-pay-with-social'] }>
            <ul className={ styles['accept-pay-list'] }>
                {acceptPayItems.map((item) => {
                    return (
                        <li
                            key={ item.key }
                            className={ styles['accept-pay-item'] }>
                            <img
                                className={ styles['accept-pay-image'] }
                                src={ item.img }
                                alt={ item.alt } />
                        </li>
                    );
                })}
            </ul>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href='href="https://www.dmca.com/Protection/Status.aspx?ID=b09397d7-7449-489d-8965-e6a9272b603a&refurl=https://reolink.com/"'
                className={ styles['dmca-link'] }
            >
                <img
                    src="https://images.dmca.com/Badges/dmca_protected_sml_120l.png?ID=b09397d7-7449-489d-8965-e6a9272b603a"
                    alt="DMCA.com Protection Status"
                />
            </a>
            <ul className={ styles['social-link-list'] }>
                {socialLinkItems.map((item) => {
                    return (
                        <li
                            key={ item.key }
                            className={ styles['social-link-item'] }>
                            <a
                                className={ styles['social-link'] }
                                href={ item.link }
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <ReoIcon
                                    className={ styles['social-link-icon'] }
                                    name={ item.icon as EIconType }
                                    width={ 22 }
                                    color="#ffffffa1"
                                />
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default CompAcceptPayWithSocial;
